import React, { useState, useEffect } from "react";
import NavHeader from "../Common/NavHeader";
import BreadCrumb from "../Common/BreadCrumb";
import useAppStore from "../../store/global";
import useSalesReceiptStore from "./store";
import { Spinner } from "react-bootstrap";
import SalesTable from "./InternalStruct/SalesTable";
import Liabilities from "./InternalStruct/Liabilities";
import Discounts from "./InternalStruct/Discounts";
import TenderTypes from "./InternalStruct/TenderTypes";
import CashAccounts from "./InternalStruct/CashAccounts";
import Expenses from "./InternalStruct/Expenses";
import AdditionalExpenses from "./InternalStruct/AdditionalExpenses";
import PaidInsAndOuts from "./InternalStruct/PaidInsAndOuts";
import GrandTotal from "./InternalStruct/GrandTotal";
import LaborTable from "./InternalStruct/LaborDataTable";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  getSalesReceiptData,
  saveExpenses,
  fetchUnverifiedItems,
  useFetchCombinedReport,
  fetchUnAssignedLaborReportItems,
  syncReportV2,
  getSyncLogsAndStatus,
} from "./api";
import { Check2Circle } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  Arrow90degLeft,
  Arrow90degRight,
  ExclamationCircleFill,
} from "react-bootstrap-icons";
import Accordion from "react-bootstrap/Accordion";
import { ListGroup } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { getScrapperProcesses } from "../Reports/api";
import DiscountTable from "../Classification/Discount/DiscountTable";
import MenuMixTable from "../Classification/MenuMix/MenuMixTable";
import LT from "../Classification/Labor/LaborTable";
import {
  changeDiscountCategory,
  changeLaborClassCategory,
  changeMenuMixCategory,
} from "../Classification/api";
import {
  updateRawLabor,
  addNewLaborClass,
  getAllLaborClasses,
} from "../Reports/api";
import LabourTable from "../Reports/Labour/LabourTable";
export default function SalesReceipt() {
  const { setDateRange } = useAppStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const [approveLoading, setApproveLoading] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const date = searchParams.get("date");
  const restName = searchParams.get("restaurant_name");
  const { loading, setLoading } = useAppStore();
  const [syncing, setSyncing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [replaceExisting, setReplaceExisting] = useState(false);
  const [fetchingUnverifiedItems, setFetchingUnverifiedItems] = useState(false);
  const [scrapperProcesses, setScrapperProcesses] = useState([]);
  const [unverifiedDiscounts, setUnverifiedDiscounts] = useState([]);
  const [unverifiedMenuItems, setUnverifiedMenuItems] = useState([]);
  const [unverifiedLaborItems, setUnverifiedLaborItems] = useState([]);
  const [unverifiedLaborReprt, setUnverifiedLaborReprt] = useState([]);
  const [allLaborClasses, setAllLaborClasses] = useState([]);
  const [unverifiedTableView, setUnverifiedTableView] = useState("discounts");
  const [isInProgress, setIsInProgress] = useState(false);
  const [refetching, setRefetching] = useState(false);
  const { id } = useParams();
  const [reportDate, setReportDate] = useState(
    new Date(date).toISOString().split("T")[0]
  );
  const {
    setCategoryWiseSales,
    setLiabilities,
    setDiscounts,
    setTenderTypes,
    setCashAccounts,
    setExpenses,
    setCreditCardFees,
    setTodaysCreditCardFees,
    setLaborData,
    setAskMyClient,
    setCashOverUnderEditable,
    setCashOverUnder,
    askMyClient,
    cashOverUnderEditable,
    grandTotall,
    setReportStatus,
    reportStatus,
    clickBaconStatus,
    setClickBaconStatus,
    setLastSyncedAt,
    lastSyncedAt,
    setSyncLogs,
    syncLogs,
    setHasGiftCardIssue,
    setHasUncategorizedLabor,
    hasGiftCardIssue,
    hasUncategorizedLabor,
    hasDiscountIssue,
    setExtractedDiscount,
    setServiceRevenue,
    setPaidIns,
    setPaidOuts,
    setPaidInOutId,
    setIsPaidInOutSynced,
    setPaidInOutSyncedAt,
    setPaidInOutSyncLogs,
    paidInOutSyncLogs,
    setGrandTotalNew,
    grandTotalNew,
  } = useSalesReceiptStore();

  const fetchSalesReceiptData = async () => {
    setRefetching(true);
    getSalesReceiptData(id, date)
      .then((data) => {
        setCategoryWiseSales(data.sales_summary_data.category_wise_sale);
        if (data.sales_summary_data.category_wise_sale.length === 0) {
          toast.warning(
            "No Product Report found for this date. Please re-extract the reports for this date."
          );
        }
        setLiabilities(data.sales_summary_data.liability_collected);
        setDiscounts(data.sales_summary_data.discounts);
        setTenderTypes(data.sales_summary_data.tender_type);
        setCashAccounts(data.sales_summary_data.cash_accounts);
        setExpenses(data.sales_summary_data.expenses);
        setCreditCardFees(data.sales_summary_data.credit_card_fee);
        setPaidInOutId(data.sales_summary_data.paid_in_out_id);
        setIsPaidInOutSynced(data.sales_summary_data.paid_in_out_sync);
        setPaidInOutSyncedAt(data.sales_summary_data.paid_in_out_synced_at);
        setPaidInOutSyncLogs(data.sales_summary_data.paid_in_out_sync_logs);
        setGrandTotalNew(data.sales_summary_data.grand_total);
        setTodaysCreditCardFees(
          data.sales_summary_data?.cc_fee_from_todays_report
        );
        const laborData = data.sales_summary_data?.labor_data;



        setLaborData(laborData);
        // } else {
        //   setLaborData([]);
        // }
        // setLaborData(data.sales_summary_data?.labor_data);
        setAskMyClient(data.sales_summary_data?.ask_my_client);
        setCashOverUnderEditable(
          data.sales_summary_data?.cash_over_under_editable
        );
        setCashOverUnder(data.sales_summary_data?.cash_over_under);
        setLastSyncedAt(data.sales_summary_data?.last_sync_date);
        setServiceRevenue(data.sales_summary_data?.service_revenue);
        setPaidIns(data.sales_summary_data?.paid_ins);
        setPaidOuts(data.sales_summary_data?.paid_outs);
        // Check for issues

        getUnverifiedItems();
        getUnassignedLaborReport();
        handleGetAllLaborClasses();
        setRefetching(false);
      })
      .catch((err) => {
        setRefetching(false);
        console.log("error", err);
      });
  };
  useEffect(() => {
    setLoading(true);
    getScrapperProcesses(1, 10, id)
      .then((datax) => {
        setScrapperProcesses(datax.scrapper_processes);
        console.log("firstsie", datax.scrapper_processes);
        getSalesReceiptData(id, date)
          .then((data) => {
            setCategoryWiseSales(data.sales_summary_data.category_wise_sale);
            if (data.sales_summary_data.category_wise_sale.length === 0) {
              toast.warning(
                "No Product Report found for this date. Please re-extract the reports for this date."
              );
            }
            setLiabilities(data.sales_summary_data.liability_collected);
            setDiscounts(data.sales_summary_data.discounts);
            setTenderTypes(data.sales_summary_data.tender_type);
            setCashAccounts(data.sales_summary_data.cash_accounts);
            setExpenses(data.sales_summary_data.expenses);
            setCreditCardFees(data.sales_summary_data.credit_card_fee);
            setPaidInOutId(data.sales_summary_data.paid_in_out_id);
            setIsPaidInOutSynced(data.sales_summary_data.paid_in_out_sync);
            setPaidInOutSyncedAt(data.sales_summary_data.paid_in_out_synced_at);
            setPaidInOutSyncLogs(data.sales_summary_data.paid_in_out_sync_logs);
            setGrandTotalNew(data.sales_summary_data.grand_total);
            setTodaysCreditCardFees(
              data.sales_summary_data?.cc_fee_from_todays_report
            );
            const laborData = data.sales_summary_data?.labor_data;



            setLaborData(laborData);
            // setLaborData(data.sales_summary_data?.labor_data);
            setAskMyClient(data.sales_summary_data?.ask_my_client);
            setCashOverUnderEditable(
              data.sales_summary_data?.cash_over_under_editable
            );
            setCashOverUnder(data.sales_summary_data?.cash_over_under);
            setLastSyncedAt(data.sales_summary_data?.last_sync_date);
            setServiceRevenue(data.sales_summary_data?.service_revenue);
            setPaidIns(data.sales_summary_data?.paid_ins);
            setPaidOuts(data.sales_summary_data?.paid_outs);
            // Check for issues

            // ``` Gift Card Issue -- If discount has a discount named Gift Card Sold,
            // but if that's not present in the category wise sale, then set hasGiftCardIssue to true.```
            // If the restaurant does not use toast, then set gift card issue to false be it anything.
            const isToastPresent = datax.scrapper_processes.find(
              (process) => process.pos_name === "toast"
            );
            if (isToastPresent) {
              //toast.success("toast is present");
              const giftCardDiscount =
                data.sales_summary_data.liability_collected.find(
                  (discount) => discount.liability_name === "Gift Card Sold"
                );
              if (giftCardDiscount) {
                const giftCardCategory =
                  data.sales_summary_data.category_wise_sale.find(
                    (salesCategory) => salesCategory.category === "Gift Card"
                  );
                if (!giftCardCategory) {
                  setHasGiftCardIssue(true);
                }
              } else {
                setHasGiftCardIssue(false);
              }
            } else {
              setHasGiftCardIssue(false);
            }

            setExtractedDiscount(
              data.sales_summary_data?.total_discounts_extracted
            );
            getUnverifiedItems();
            getUnassignedLaborReport();
            handleGetAllLaborClasses();
            setLoading(false);
          })
          .catch((err) => {
            console.log("error", err);
          });
      })

      .catch((err) => {
        console.log("error", err);
      });
    getSyncLogsAndStatus(id, date)
      .then((data) => {
        setSyncLogs(data.sync_logs);
        setClickBaconStatus(data.clickbacon_status);
        setReportStatus(data.qbo_status);
      })
      .catch((err) => {
        console.log("error", err);
      });
  }, [id, date]);

  const handleSync = () => {
    setSyncing(true);
    const body = {
      restaurant_id: id,
      report_date: date,
      force_sync: reportStatus ? true : false,
      replace_existing: replaceExisting,
      sync_mode: "qbo",
    };

    syncReportV2(body)
      .then((data) => {
        setSyncing(false);
        setReplaceExisting(false);
        setShowModal(false);
        toast.success(data?.message);
      })
      .catch((err) => {
        setSyncing(false);
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const handleSaveExpenses = () => {
    setSaving(true);
    const body = {
      restaurant_id: id,
      report_date: date,
      ask_my_client: askMyClient,
      cash_over_under_editable: cashOverUnderEditable,
    };
    saveExpenses(body)
      .then((data) => {
        setSaving(false);
        fetchSalesReceiptData();
        toast.success(data.message);
      })
      .catch((err) => {
        setSaving(false);
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const handlePrevious = () => {
    const previousDate = new Date(date);
    previousDate.setDate(previousDate.getDate() - 1);
    setSearchParams({
      date: previousDate.toISOString().split("T")[0],
      restaurant_name: restName,
    });
  };

  const handleNext = () => {
    const nextDate = new Date(date);
    nextDate.setDate(nextDate.getDate() + 1);
    setSearchParams({
      date: nextDate.toISOString().split("T")[0],
      restaurant_name: restName,
    });
  };

  const handleGoto = (date) => {
    setSearchParams({ date: date, restaurant_name: restName });
  };

  const getUnverifiedItems = () => {
    setFetchingUnverifiedItems(true);
    fetchUnverifiedItems(id, date)
      .then((data) => {
        // backend stopped sending unverified_menu_data (crunch-backend 3ac579a)
        const {
          unverified_discount_data = [],
          unverified_menu_data = [],
          unverified_labour_data = [],
        } = data.unverified_data;

        // Function to filter unique items
        const filterUniqueItems = (items) => {
          const uniqueItems = [];
          const seen = new Set();

          items.forEach((item) => {
            const itemString = JSON.stringify(item);
            if (!seen.has(itemString)) {
              seen.add(itemString);
              uniqueItems.push(item);
            }
          });

          return uniqueItems;
        };
        const uniqueUnverifiedDiscounts = filterUniqueItems(
          unverified_discount_data
        );
        // Filter unique unverified menu items
        const uniqueUnverifiedMenuItems =
          filterUniqueItems(unverified_menu_data);

        const uniqueUnverifiedLaborItems = filterUniqueItems(
          unverified_labour_data
        );
        setUnverifiedDiscounts(uniqueUnverifiedDiscounts);
        setUnverifiedMenuItems(uniqueUnverifiedMenuItems);
        setUnverifiedLaborItems(uniqueUnverifiedLaborItems);

        setFetchingUnverifiedItems(false);
      })
      .catch((err) => {
        setFetchingUnverifiedItems(false);
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const getUnassignedLaborReport = () => {
    fetchUnAssignedLaborReportItems(id, date)
      .then((data) => {
        setUnverifiedLaborReprt(data.labour_report);
        if (data.labour_report.length > 0) {
          setHasUncategorizedLabor(true);
        } else {
          setHasUncategorizedLabor(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  const handleModalShow = () => {
    setShowApprovalModal(true);
  };

  const handleCategoryChangeDiscount = (Discount_id, category) => {
    setApproveLoading(true);
    changeDiscountCategory(Discount_id, category)
      .then((data) => {
        toast.success(data.message);
        setApproveLoading(false);
        getUnverifiedItems();
      })
      .catch((err) => {
        setApproveLoading(false);
        toast.error(err.message);
      });
  };

  const handleCategoryChangeLabor = (labor_id, category) => {
    setApproveLoading(true);
    changeLaborClassCategory(labor_id, category)
      .then((data) => {
        toast.success(data.message);
        setApproveLoading(false);
        getUnverifiedItems();
      })
      .catch((err) => {
        setApproveLoading(false);
        toast.error(err.message);
      });
  };

  const handleCategoryChangeMenuMix = (pmix_id, category) => {
    setApproveLoading(true);
    changeMenuMixCategory(pmix_id, category)
      .then((data) => {
        toast.success(data.message);
        setApproveLoading(false);
        getUnverifiedItems();
      })
      .catch((err) => {
        setApproveLoading(false);
        toast.error(err.message);
      });
  };

  const [syncingToBacon, setSyncingToBacon] = useState(false);

  const handleSyncV2 = () => {
    const body = {
      restaurant_id: id,
      report_date: date,
      force_sync: true,
      replace_existing: clickBaconStatus ? true : false,
      sync_mode: "clickbacon",
    };
    setSyncingToBacon(true);
    syncReportV2(body)
      .then((data) => {
        toast.success(data.message);
        setSyncingToBacon(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
        setSyncingToBacon(false);
      });
  };

  const {
    data: combinedReportData,
    isLoading,
    isError,
    error,
  } = useFetchCombinedReport(id, date);

  const base64StringToBlob = async (base64String) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    return blob;
  };

  const handleDownloadClick = async () => {
    setIsInProgress(true);
    try {
      const blob = await base64StringToBlob(combinedReportData?.encoded_file);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${restName}-${date}-Combined_Report.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      setIsInProgress(false);
    } catch (error) {
      setIsInProgress(false);
      toast.error("File not available");
    }
  };

  const handleSeeReport = (type) => {
    let updatedDate = new Date(date);
    updatedDate.setUTCHours(18, 30, 0, 0);
    updatedDate.setDate(updatedDate.getDate() - 1);
    const updatedDateRange = [
      {
        startDate: updatedDate.toISOString(),
        endDate: updatedDate.toISOString(),
        key: "selection",
      },
    ];
    setDateRange(updatedDateRange);
    window.open(`/restaurants/${id}/${type}/`, "_blank", "noopener,noreferrer");
  };

  const handleGetAllLaborClasses = () => {
    getAllLaborClasses(id)
      .then((data) => {
        setAllLaborClasses(data.labor_classes);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdateRawLabor = (labor_obj_id, labor_id) => {
    setLoading(true);
    updateRawLabor(labor_obj_id, labor_id)
      .then((data) => {
        toast.success(data.message);
        getUnassignedLaborReport();
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  const handleAddNewLaborClass = (posId, jobTitle, laborCategory) => {
    const body = {
      restaurant_id: id,
      pos_id: posId,
      job_title: jobTitle,
      labor_category: laborCategory,
    };
    addNewLaborClass(body)
      .then((data) => {
        toast.success(data.message);
        handleGetAllLaborClasses();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <>
      <NavHeader view="SalesReceipt" />
      <ToastContainer />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} >  Sales Receipt`} />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <div className="row justify-content-between align-items-center border-white shadow sm rounded mx-3 my-4 p-3">
              <div className="d-flex flex-wrap my-0 justify-content-end align-items-center">
                <span
                  className="text-muted mx-2"
                  style={{
                    fontSize: "0.9rem",
                    textDecoration: "underline",
                    cursor: "pointer",
                    marginTop: "14px",
                  }}
                  onClick={handleDownloadClick}
                  cursor={isError ? "not-allowed" : "pointer"}
                >
                  <OverlayTrigger
                    key={"top"}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`tooltip-category-wise-sale`}>
                        {isError ? (error?.response?.data?.message || "Something went wrong") : "View Combined Report"}
                      </Tooltip>
                    }
                  >
                    <p
                      className={
                        "fs-32 mx-3 my-1" +
                        (isError ? " text-danger" : "text-muted")
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <ExclamationCircleFill className="mx-2" />
                      {isInProgress ? "Downloading..." : "Combined Report"}
                    </p>
                  </OverlayTrigger>
                </span>
                <span
                  className="text-muted mx-2"
                  style={{
                    fontSize: "0.9rem",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={handlePrevious}
                >
                  <Arrow90degLeft className="mx-2" />
                  Previous
                </span>
                <span
                  className="text-muted mx-2"
                  style={{
                    fontSize: "0.9rem",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={handleNext}
                >
                  Next
                  <Arrow90degRight className="mx-2" />
                </span>
                <span>
                  <input
                    type="date"
                    className="mx-2 form-control p-0 w-100 text-center"
                    value={date}
                    onChange={(e) => {
                      handleGoto(e.target.value);
                    }}
                  />
                </span>
              </div>

              <div className="col-md-6">
                <label className="form-label">Source:</label>
                <input
                  type="text"
                  className="form-control"
                  value={"POS"}
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  readOnly
                />
              </div>
              <div className="col-md-3 mt-1">
                <label className="form-label">QBO Status</label>
                <input
                  type="text"
                  className="form-control"
                  value={reportStatus ? "Synced" : "Pending"}
                  readOnly
                  style={{
                    textTransform: "capitalize",
                  }}
                />
              </div>
              <div className="col-md-3 mt-1">
                <label className="form-label">clickBACON Status</label>
                <input
                  type="text"
                  className="form-control"
                  value={clickBaconStatus ? "Synced" : "Pending"}
                  readOnly
                  style={{
                    textTransform: "capitalize",
                  }}
                />
              </div>
              <div className="col-md-6 mt-1">
                <label className="form-label">Last Sync Date</label>
                <input
                  type="text"
                  className="form-control"
                  value={syncLogs[0]?.sync_date || "NA"}
                  readOnly
                />
              </div>

              <Accordion className="col-md-6 my-3">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Sync Logs</Accordion.Header>
                  <Accordion.Body>
                    <ListGroup variant="flush">
                      {syncLogs?.map((log, index) => (
                        <ListGroup.Item
                          key={index}
                          className={`bg-dark ${
                            log.log_level === "ERROR"
                              ? "text-danger"
                              : log.log_level === "WARNING"
                              ? "text-warning"
                              : "text-white"
                          }`}
                        >
                          {log.sync_date} - {log.sync_logs}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div className="col-md-6">
                {unverifiedDiscounts.length > 0 ||
                unverifiedMenuItems.length > 0 ||
                unverifiedLaborReprt.length > 0 ||
                unverifiedLaborItems.length > 0 ? (
                  <Button
                    style={{
                      width: "100%",
                    }}
                    variant="danger"
                    onClick={handleModalShow}
                    disabled={approveLoading}
                  >
                    Click Here To Approve Unverified Items
                  </Button>
                ) : (
                  <Button
                    style={{
                      width: "100%",
                    }}
                    variant="success"
                  >
                    No Unverified Items
                  </Button>
                )}
              </div>
              <div className="col-md-12  d-flex justify-content-end">
                <div className="col-md-3 d-flex justify-content-end">
                  <div className="mx-2">
                    <p
                      className={
                        hasGiftCardIssue ? "text-danger" : "text-success"
                      }
                      onClick={() => {
                        handleSeeReport("pmix-reports");
                      }}
                    >
                      {!hasGiftCardIssue && <Check2Circle className="mx-1" />}
                      Sales
                    </p>
                  </div>
                  <div className="mx-2">
                    <p
                      className={
                        hasDiscountIssue ? "text-danger" : "text-success"
                      }
                      onClick={() => {
                        handleSeeReport("discount-reports");
                      }}
                    >
                      {!hasDiscountIssue && <Check2Circle className="mx-1" />}
                      Discount
                    </p>
                  </div>
                  <div className="mx-2">
                    <p
                      className={
                        hasUncategorizedLabor ? "text-danger" : "text-success"
                      }
                      onClick={() => {
                        handleSeeReport("labour-reports");
                      }}
                    >
                      {!hasDiscountIssue && <Check2Circle className="mx-1" />}
                      Labor
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <SalesTable />
            {/* <ServiceRevenue/> */}
            {/* <div className="mx-3 row justify-content-between"> */}
            <Liabilities />
            <Discounts />
            {/* </div> */}
            <TenderTypes />
            <CashAccounts />
            <Expenses
              handleSaveExpenses={handleSaveExpenses}
              saving={saving}
              refetching={refetching}
            />
            <AdditionalExpenses />
            <GrandTotal
              getSalesReceiptData={fetchSalesReceiptData}
              refetching={refetching}
            />
            <PaidInsAndOuts type="Paid Ins" />
            <PaidInsAndOuts type="Paid Outs" />
            <LaborTable />
              <div className="border-white d-flex flex-column flex-md-row gap-2 justify-content-between shadow-sm rounded mx-md-3 my-4 p-3">
                <OverlayTrigger
                  key={"top"}
                  placement={"top"}
                  overlay={
                    <Tooltip id={`tooltip-synced-with-bacon`}>
                      {clickBaconStatus
                        ? "This would replace the existing clickBACON report"
                        : "Sync to clickBACON"}
                    </Tooltip>
                  }
                >
                  <button
                    className="btn btn-info w-100"
                    onClick={() => {
                      if (reportStatus) {
                        setShowModal(true);
                      } else {
                        handleSyncV2();
                      }
                    }}
                    disabled={
                      syncingToBacon ||
                      grandTotalNew == "NA" ||
                      Math.abs(grandTotalNew)?.toFixed(2) !== "0.00" ||
                      hasGiftCardIssue ||
                      hasUncategorizedLabor ||
                      hasDiscountIssue
                    }
                  >
                    {syncingToBacon
                      ? "Processing.... Please wait"
                      : "Accept and Sync"}
                  </button>
                </OverlayTrigger>
              </div>

            <Modal
              show={showModal}
              onHide={() => {
                setReplaceExisting(false);
                setShowModal(false);
              }}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Already Synced
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h6>Do you want to</h6>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    checked={!replaceExisting}
                    onChange={() => {
                      setReplaceExisting(false);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    Create Duplicate
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    checked={replaceExisting}
                    onChange={() => {
                      setReplaceExisting(!replaceExisting);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault2"
                  >
                    Replace Existing
                  </label>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={handleSync} disabled={syncing}>
                  {syncing ? "Processing ..." : "Sync"}
                </Button>
                <Button
                  variant="danger"
                  onClick={() => {
                    setReplaceExisting(false);
                    setShowModal(false);
                  }}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showApprovalModal}
              onHide={() => {
                setShowApprovalModal(false);
              }}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Approve Unverified Items
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {fetchingUnverifiedItems ? (
                  <div className="text-center">
                    <Spinner
                      animation="border"
                      className="mx-auto text-center my-4"
                    />
                  </div>
                ) : (
                  <>
                    <div className="d-flex flex-wrap gap-2 justify-content-end mb-2">
                      {unverifiedDiscounts.length > 0 && (
                        <div className="mx-2">
                          <Button
                            variant="primary"
                            onClick={() => setUnverifiedTableView("discounts")}
                            disabled={unverifiedTableView === "discounts"}
                          >
                            Discount
                          </Button>
                        </div>
                      )}
                      {unverifiedMenuItems.length > 0 && (
                        <div className="mx-2">
                          <Button
                            variant="info"
                            onClick={() => setUnverifiedTableView("menu")}
                            disabled={unverifiedTableView === "menu"}
                          >
                            Menu Mix
                          </Button>
                        </div>
                      )}
                      {unverifiedLaborItems.length > 0 && (
                        <div className="mx-2">
                          <Button
                            variant="secondary"
                            onClick={() => setUnverifiedTableView("labor")}
                            disabled={unverifiedTableView === "labor"}
                          >
                            Labor
                          </Button>
                        </div>
                      )}
                      {unverifiedLaborReprt.length > 0 && (
                        <div className="mx-2">
                          <Button
                            variant="secondary"
                            onClick={() =>
                              setUnverifiedTableView("laborReport")
                            }
                            disabled={unverifiedTableView === "laborReport"}
                          >
                            Unassigned Labor
                          </Button>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        height: "450px",
                        overflowY: "auto",
                      }}
                    >
                      {unverifiedTableView === "menu" ? (
                        <MenuMixTable
                          setReports={setUnverifiedMenuItems}
                          reports={unverifiedMenuItems}
                          handleCategoryChange={handleCategoryChangeMenuMix}
                          approveLoading={approveLoading}
                        />
                      ) : unverifiedTableView === "labor" ? (
                        <LT
                          setReports={setUnverifiedLaborItems}
                          reports={unverifiedLaborItems}
                          handleCategoryChange={handleCategoryChangeLabor}
                          approveLoading={approveLoading}
                        />
                      ) : unverifiedTableView === "laborReport" ? (
                        <LabourTable
                          reports={unverifiedLaborReprt}
                          setReports={setUnverifiedLaborReprt}
                          handleCategoryChange={handleUpdateRawLabor}
                          allLaborClasses={allLaborClasses}
                          handleUpdateRawLabor={handleUpdateRawLabor}
                          handleAddNewLaborClass={handleAddNewLaborClass}
                          fetchAgain={true}
                          getUnassignedLaborReport={getUnassignedLaborReport}
                        />
                      ) : (
                        <DiscountTable
                          setReports={setUnverifiedDiscounts}
                          reports={unverifiedDiscounts}
                          handleCategoryChange={handleCategoryChangeDiscount}
                          approveLoading={approveLoading}
                        />
                      )}
                    </div>
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="danger"
                  onClick={() => {
                    setShowApprovalModal(false);
                  }}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </div>
    </>
  );
}
